import { IModuleUserProgressStatus } from '../interfaces/module-user-progress-status.interface';

export enum ModuleUserProgressStatus {
    NotStarted = 'not_started',
    InProgress = 'in_progress',
    Completed = 'completed',
}

// @dynamic
export class ModuleUserProgressStatuses {
    static visibleKeys: [string, string, string] = ['not_started', 'in_progress', 'completed'];

    static all: IModuleUserProgressStatus[] = [
        {
            name: 'not_started',
            translationLabel: 'GENERAL.PROPERTY.NOT_STARTED',
            primaryColor: '#F5A622',
            secundaryColor: '#EDA027',
        },
        {
            name: 'in_progress',
            translationLabel: 'GENERAL.STATUS.IN_PROGRESS',
            primaryColor: '#61B3F2',
            secundaryColor: '#60ADE8',
        },
        {
            name: 'completed',
            translationLabel: 'GENERAL.STATUS.COMPLETED',
            primaryColor: '#4DDA8D',
            secundaryColor: '#4DD289',
        },
    ];
}
